import {useEffect, useState} from "react";
import {getColor} from "@/styles/ThemeConfig";
import styled, {css} from "styled-components";
import Image from "next/image";
import {breakpoints} from "@/styles/sizes";
import ReviewOverlay from "@/components/base/ReviewOverlay";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";
import {Button} from "@/components/base/Buttons";

const ContentWrapper = styled.div`
    //padding-right: 50px;
    position: relative;

    @media only screen and (${breakpoints.mobile}) {
        padding-right: 0;
    }

    .text_wrapper {
        padding-bottom: ${props => props?.$hasButtons ? '0px' : '4em'};
        @media only screen and (${breakpoints.mobile}) {
            padding: 40px 0;
            padding-top: 0px;
            padding-bottom: ${props => props?.$hasButtons ? '0px' : '2em'};
        }
    }
`;

const TextWrapper = styled.div`

    @media only screen and (${breakpoints.mobile}) {
        max-width: 100%;
    }
`;

const ButtonsWrapper = styled.div`
    display:flex;
    gap:20px;
    align-items:center;
    justify-content:flex-start;
    flex-wrap:wrap;
    padding-bottom: 40px;

    @media only screen and (${breakpoints.mobile}) {
        padding-left: 20px;
        padding-right: 20px;
    }
`;





export default function CityTextImageSection({reviewOverlayData,  title, description, image, buttons }) {
    const [isClient, setIsClient] = useState(false);

    // Check if the component is rendering on the client
    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <ContentWrapper $hasButtons={buttons && buttons?.length > 0}>
            <div style={{ backgroundColor: getColor("grayBackground"), padding:'50px 0' }}>
                <ReviewOverlay data={reviewOverlayData} showDesktop={false} />

                <div className={'container_small'} style={{position:'relative'}}>

                    <div style={{display:'flex', justifyContent:'space-between', gap:'50px'}}>
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    position: "relative",
                                }}
                            >
                                <div className={"text_wrapper"}>
                                    {title && (
                                        <h2
                                            className={'h1'}
                                            style={{
                                                fontFamily: "Josefin Sans",
                                                fontWeight: "bold",
                                                color: "#c49959",
                                                "marginBottom": "15px",
                                                textTransform: "uppercase",
                                                fontSize: "2.1em",
                                            }}
                                        >
                                            {title}
                                        </h2>
                                    )}

                                    {isClient && (
                                        <TextWrapper>
                                            <DangerousDescriptionWrapper
                                                customStyle={css`
                                        p {
                                            color: ${getColor('green')}!important;
                                        }
                                    `}
                                                dangerouslySetInnerHTML={{ __html: description }}
                                            />
                                        </TextWrapper>
                                    )}
                                </div>
                            </div>

                            {
                                buttons && buttons?.length > 0 && <ButtonsWrapper>
                                    {
                                        buttons?.map((item,index) => {
                                            return <Button key={index} variant={'greenTextImageSection'} href={item?.url}>
                                                {item?.text}
                                            </Button>
                                        })
                                    }
                                </ButtonsWrapper>
                            }
                        </div>


                        <Image
                            className={'desktop_only'}
                            style={{
                                // position: "absolute",
                                // top: "50%",
                                // transform: "translateY(-50%)",
                                maxWidth:'500px',
                                maxHeight:'600px',
                                objectFit:'cover',
                                objectPosition:'center',
                                height: "auto",
                                right: 0,
                            }}
                            src={image?.url}
                            alt={image?.alt ?? image?.name}
                            width={500}
                            height={600}
                        />
                    </div>


                </div>
            </div>
        </ContentWrapper>
    );
}
